import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var UserAvatar = function (_a) {
    var name = _a.name, photoUrl = _a.photoUrl, className = _a.className, size = _a.size;
    // background/color are the theme's navy and near-white (see theme.css).
    var uiAvartarUrl = "https://ui-avatars.com/api/?name=" + encodeURI(name) + "&background=023E73&size=64&color=EEF5FF";
    return ((!photoUrl) ? (_jsx("div", { className: "c-avatar", children: _jsx("img", { src: uiAvartarUrl, className: className, width: size, height: size, alt: name }) })) : (_jsx("div", { className: "c-avatar", children: _jsx("img", { src: photoUrl, className: className, width: size, height: size, alt: name }) })));
};
export default UserAvatar;
